import { createSelector } from 'reselect';

const getGlobalData = (state) => state.global;

const makeSelectGlobalData = () =>
  createSelector(getGlobalData, (globalState) => ({
    loading: globalState.loading,
    error: globalState.errorData,
    data: globalState.data,
    request: globalState.request
  }));

const makeSelectMerchantData = () =>
  createSelector(getGlobalData, (globalState) => globalState.data.merchant);

const makeSelectBrowser = () => (state) => state.browser;

const makeSelectLocationState = () => {
  return (state) => {
    const routingState = state.route;

    return routingState;
  };
};

export {
  makeSelectBrowser,
  makeSelectGlobalData,
  makeSelectMerchantData,
  makeSelectLocationState
};
